import { render, staticRenderFns } from "./hsiiItemCopy.vue?vue&type=template&id=d60fc8b0"
import script from "./hsiiItemCopy.vue?vue&type=script&lang=js"
export * from "./hsiiItemCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports